import React, { useState } from "react";
import { Formik, Field } from "formik";
import { Modal, Form, Grid, Button } from "semantic-ui-react";
import "react-html5-camera-photo/build/css/index.css";
import { isTabletOrLess } from "utils/isMobile";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";

const QRReaderPrescriptionModal = ({ open, submit, close }) => {
	const [scanInputValue, setScanInputValue] = useState("");

	const getScan = () => {
		submit(scanInputValue);
		close();
	};

	const handleKeyDown = (event) => {
		if (event.key === "Enter" && scanInputValue) getScan();
	};

	const handleInputChange = (e) => setScanInputValue(e.target.value);

	return (
		<Modal size={isTabletOrLess ? "small" : "large"} open={open} closeOnEscape closeOnDimmerClick onClose={close}>
			<Modal.Header>Scanner votre code</Modal.Header>
			<Modal.Content>
				<Formik enableReinitialize initialValues={{ scannedValue: "" }}>
					<Form>
						<Grid columns={1}>
							<Grid.Row>
								<Grid.Column>
									<Field
										component={CustomInputTextComponent}
										autoFocus
										autoComplete="off"
										customlabel="Valeur du code scanné"
										type="text"
										name="scannedValue"
										value={scanInputValue}
										onChange={handleInputChange}
										onKeyDown={handleKeyDown}
									/>
								</Grid.Column>
							</Grid.Row>
						</Grid>
					</Form>
				</Formik>
			</Modal.Content>
			<Modal.Actions>
				<Button onClick={close}>Annuler</Button>
				<Button primary onClick={getScan} disabled={!scanInputValue}>
					Confirmer
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

export default QRReaderPrescriptionModal;
